import axios from 'axios';
import axiosInstance from '../../../_utils/axiosConfig';

let Lieu : any = {};

Lieu.submitForm = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/loisir/add`, data)
}

Lieu.verifyLoisirForm = async(data:any)=>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/loisir/verify`,data)
}

Lieu.submitFormPopUp = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/lieu/loisir/update/popuploi`, data)
}

Lieu.getHomeData = async (code:string) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/loisir/home/${code}`)
}

Lieu.getAllData = async (code:string) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/loisir/all/${code}`)
}

Lieu.submitReservation = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/loisir/send/reservation`, data)
}

Lieu.submitEdit = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/loisir/edit`, data)
}

Lieu.getOne = async (id:any) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/loisir/show/${id}`)
}

Lieu.getImages = async (id:any) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/loisir/images/${id}`)
}


export default Lieu;